export enum SignInCommand {
    switchUser = 'switchUser',
}
